import { createFileRoute } from "@tanstack/react-router"
import { WmsOperationalDashboard } from "../../../components/WMS/Dashboard/WmsOperationalDashboard"

// Route wires the main operational WMS dashboard into file-based routing.
export const Route = createFileRoute("/_layout/WMS/dashboard")({
  component: WmsOperationalDashboard,
})
